<template>
  <div
    class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-72 mx-8 my-4 h-48 flex flex-col"
  >
    <div class="px-4 py-6 sm:p-6">
      <div class="flex flex-row justify-between items-center">
        <span>Credit Card</span>
        <button
          @click="onDelete"
          :disabled="pending"
          class="text-red-600 hover:text-red-500 button-icon"
        >
          <XIcon class="h-5" />
        </button>
      </div>
      <div class="mt-10 flex flex-row flex-grow justify-between">
        <div>**** **** **** {{ data.card.last4 }}</div>
        <div>
          {{
            data.card.exp_month > 9
              ? data.card.exp_month
              : `0${data.card.exp_month}`
          }}/{{ data.card.exp_year }}
        </div>
      </div>
    </div>
    <button @click="onUpdate" class="button-submit py-4 mt-0 rounded-none">
      <a class="text-base">Update</a>
    </button>
  </div>
</template>
<script>
import { XIcon } from "@heroicons/vue/solid";

export default {
  name: "PaymentMethodCard",
  components: {
    XIcon,
  },
  inject: ["editCreditCardModal"],
  props: {
    data: {
      type: Object,
      required: true,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async onUpdate() {
      this.editCreditCardModal.value.openModal(this.data);
    },
    onDelete() {
      this.$emit('delete-requested', this.data.id);
    },
  },
};
</script>
